import { Typography, Paper, Link, Box } from '@mui/material';
import PublicLayout from '../components/PublicLayout';

// Open Contracting Data Publication Policy, as adopted by the Taraba State
// Bureau of Public Procurement. The OCDS packages cite this page as their
// publicationPolicy, so its address must not change.

const DATA_URL = 'https://procurement.tarabastate.gov.ng/api/ocds';

const SECTIONS = [
  ['Publisher', ['Taraba State Bureau of Public Procurement (TSBPP), on behalf of the Taraba State Government.']],
  ['Scope', ['All procurement processes conducted through the Taraba State E-Procurement Portal by Ministries, Departments and Agencies onboarded onto the portal, with a contract value at or above \u20A610,000 (ten thousand naira), together with records of earlier procurement by those Ministries, Departments and Agencies transcribed onto the portal.']],
  ['Stages published', ['Planning, tender, award and contract. The implementation stage will be published once arrangements for the supply of payment and milestone data are established.']],
  ['Exclusions', [
    'Information whose disclosure is restricted under section 17(2)(b) of the Taraba State Public Procurement Law, 2012, including procurement relating to security and defence, and material that is commercially confidential.',
    'Personal contact details of individuals, such as the names and telephone numbers of contact persons, are not published.',
  ]],
  ['Licence', ['Open Data Commons Public Domain Dedication and Licence (PDDL) version 1.0. The data may be freely shared, adapted and reused, including for commercial purposes.']],
  ['Update frequency', ['Continuous, with records published following internal approval.']],
  ['Format and access', [
    'Open Contracting Data Standard version 1.1, published as release packages and record packages in JSON, available without registration or charge through a public interface on the portal.',
    'Each contracting process is identified by an Open Contracting ID beginning ocds-7v77i4, the prefix allocated to the Taraba State Bureau of Public Procurement by the Open Contracting Partnership.',
  ]],
];

export default function PublicationPolicy() {
  return (
    <PublicLayout maxWidth="md">
      <Typography variant="overline" color="primary">Open data</Typography>
      <Typography variant="h4" component="h1" gutterBottom>Open Contracting Data Publication Policy</Typography>
      <Typography color="text.secondary" sx={{ mb: 3 }}>Taraba State Bureau of Public Procurement</Typography>

      <Paper variant="outlined" sx={{ p: 3, mb: 3 }}>
        <Typography variant="h6" gutterBottom>About the data</Typography>
        <Typography paragraph>
          The portal publishes its tenders and contracts in the Open Contracting Data Standard (OCDS), the
          international format used by governments to publish information about public contracts. Anyone may
          download and reuse the data, free of charge and without registering.
        </Typography>
        <Typography>
          Data:{' '}
          <Link href={DATA_URL} underline="hover">{DATA_URL}</Link>
        </Typography>
      </Paper>

      <Paper variant="outlined" sx={{ p: 3 }}>
        {SECTIONS.map(([title, paras]) => (
          <Box key={title} sx={{ mb: 2.5 }}>
            <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 600 }}>{title}</Typography>
            {paras.map((p) => <Typography key={p.slice(0, 24)} sx={{ mb: 1 }}>{p}</Typography>)}
          </Box>
        ))}
        <Box sx={{ mb: 2.5 }}>
          <Typography variant="subtitle1" color="primary" sx={{ fontWeight: 600 }}>Data queries</Typography>
          <Typography>
            Queries concerning the published data may be directed to{' '}
            <Link href="mailto:contactcentre@tarabastate.gov.ng" underline="hover">contactcentre@tarabastate.gov.ng</Link>.
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Adopted by the Taraba State Bureau of Public Procurement, October 2026.
        </Typography>
      </Paper>
    </PublicLayout>
  );
}
